// extracted by mini-css-extract-plugin
export default {"confirm-email-header":"confirmEmail_confirm-email-header__Pdlnz","confirm-email-text":"confirmEmail_confirm-email-text__dVt0h"};